module.exports = __webpack_public_path__ + "static/media/logo.77e7b64d.jpg";